//Log levels action types
export const LOAD_PLUGINS_START = 'LOG_LEVELS|LOAD_PLUGINS_START';
export const LOAD_PLUGINS_SUCCESS = 'LOG_LEVELS|LOAD_PLUGINS_SUCCESS';
export const LOAD_PLUGINS_FAIL = 'LOG_LEVELS|LOAD_PLUGINS_FAIL';

export const SAVE_PLUGIN_LEVEL_START = 'LOG_LEVELS|SAVE_PLUGIN_LEVEL_START';
export const SAVE_PLUGIN_LEVEL_SUCCESS = 'LOG_LEVELS|SAVE_PLUGIN_LEVEL_SUCCESS';
export const SAVE_PLUGIN_LEVEL_FAIL = 'LOG_LEVELS|SAVE_PLUGIN_LEVEL_FAIL';
